export const fruitedRice = {
  id: "fruitedRice",
  link: "/#/recipes/recipes/fruitedRice",
  name: "Fruited Rice",
  cuisine: "Alethi Women's Food",
  summary: "Spiced rice with dried fruit and nuts",
  inspiration: "Pilaf",
  quantity: "4 servings",
  time: "1 hour",
  notes:
    "This recipe was one of our favorites. I chose basmati rice (as opposed to other varieties, such as short grain) to go with the other Indian influences in Alethi food. You can use whatever dried fruit you have on hand. Just try and avoid fruit that's been candied, crystallized, or otherwise covered in sugar. I chose kiwi for scalespray fruit, prunes (dried plums) for palafruit, and then apricots and dates as additional fruit that seemed to fit. For the kiwi, I wasn't able to find a store selling dried kiwi that wasn't covered in sugar. Instead I dehydrated it myself - if you don't have access to a dehydrator, you can do this in your oven at low temperatures for a long time.",
  quotes:
    "[He] told one of his servants to go fetch some flatbread and fruited tallew rice. (The Way of Kings ch 37)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/fruited-tallew-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "rice",
          display: "1 1/2 cups basmati rice"
        },
        {
          item: "nuts",
          display: "1/4 cup sliced or slivered almonds"
        },
        {
          item: "onion",
          display: "1/2 onion"
        },
        {
          item: "coconut",
          display: "3 tbsp coconut oil"
        },
        {
          item: "aniseSeed",
          display: "1/2 tsp anise seeds"
        },
        {
          item: "corianderSeed",
          display: "1/2 tsp coriander seeds"
        },
        {
          item: "cumin",
          display: "1/2 tsp ground cumin"
        },
        {
          item: "turmeric",
          display: "1/2 tsp ground turmeric"
        },
        {
          item: "garlicClove",
          display: "2 cloves garlic, minced"
        },
        {
          item: "salt",
          display: "1 tsp salt"
        },
        {
          item: "water",
          display: "2 1/2 cups water, plus additional for washing"
        },
        {
          item: "driedFruit",
          display:
            "1/2 cup finely chopped dried fruit, lightly packed (such as kiwi, prunes, apricots, dates)"
        }
      ]
    }
  ],
  steps: [
    "Wash the rice until the water runs clear. Set aside to drain in a mesh strainer.",
    "Spread almonds in a single layer in a pot over medium heat. Toast and stir until browned. Remove from pot and set aside.",
    "Add the coconut oil to the pot, then dice the onion and add it to the pan. Saute until translucent.",
    "Add anise seeds, coriander seeds, cumin, turmeric, garlic and salt to the onions. Cook and stir for a minute.",
    "Add the drained rice to the pot. Cook and stir until it begins to sizzle, then cook and stir 3 minutes more.",
    "Add 2 1/2 cups water and the chopped dried fruit. Cover and bring to a boil. Reduce heat to very low and let sit 25 minutes.",
    "Remove from heat, add toasted almonds, then fluff with a fork."
  ]
}
